import { render, staticRenderFns } from "./TipoArticuloSelector.vue?vue&type=template&id=4780b1e5"
import script from "./TipoArticuloSelector.vue?vue&type=script&lang=js"
export * from "./TipoArticuloSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports